import { useEntityAPI } from '../../../redux/entity-api.hook';
import { statusTypeAPI } from '../redux/status-type.slice';

export function useStatusTypes() {
  return useEntityAPI(statusTypeAPI);
}
